import React from "react";
import DropDown from "./DropDown";
import Card from "./Card";
export default function Home(props) {
  const [search, setSearch] = React.useState("");

  const access = () => {
    let newArray = [];
    Object.keys(props.codes.category)
      .map(category => {
        return props.codes.category[category];
      })
      .map(item => {
        return Object.keys(item);
      })
      .map(next => {
        return next.forEach(inner => {
          newArray.push(inner);
        });
      });
    return newArray;
  };

  const filterItems = (arr, query) => {
    return arr.filter(function(el) {
      return el.toLowerCase().indexOf(query.toLowerCase()) !== -1;
    });
  };
  filterItems(access(), search);

  const searchTerm = filterItems(access(), search);

  const compare = (a, b) => {
    if (a.alt < b.alt) {
      return -1;
    }
    if (a.alt > b.alt) {
      return 1;
    }
    return 0;
  };

  const generateCards = () => {
    let mapMe = [];
    Object.keys(props.codes.category).forEach(cat => {
      searchTerm.forEach(eachSearch => {
        if (props.codes.category[cat][eachSearch] !== undefined) {
          mapMe.push(props.codes.category[cat][eachSearch]);
        }
      });
    });
    return mapMe;
  };

  const filteredArrayToRender = generateCards().sort(compare);

  return (
    <>
      {console.log(props.codes)}
      <h1>Discountify</h1>
      <input
        className="active constrainedButton searchForm"
        value={search}
        onChange={e => setSearch(e.target.value)}
        type="text"
        placeholder="Search"
      />

      {search.length ? (
        filteredArrayToRender.map((item, i) => {
          return (
            <div key={i + item} className="cardWrapper">
              <Card
                key={i + props.codes}
                codes={item.code}
                section={props.section}
                img={item.img}
                code={item.code}
                darkLogo={item.darkLogo}
                darkBackground={item.darkBackground}
                googlePlay={props.codes.googlePlay}
                appStore={props.codes.appStore}
              />
            </div>
          );
        })
      ) : (
        <DropDown codes={props.codes} />
      )}
    </>
  );
}
